define.alias("shared/models/linkedin-post", "settings/models/linkedin-post");